<template>
    <div>
        <div v-for="(quiz,index) in contents.currentSlide.quiz">
            <div v-if="quiz.type == 'ox'">
                <aw-ox-quiz
                    v-show="currentQuiz == index"
                    :quiz=quiz
                    :order="index"
                    v-on:answered="answered"
                    v-on:goQuizNext="goQuizNext"
                ></aw-ox-quiz>
            </div>
            <div v-else-if="quiz.type == 'multiple'">
                <aw-multiple-quiz
                    v-show="currentQuiz == index"
                    :quiz=quiz
                    :order="index"
                    v-on:answered="answered"
                    v-on:goQuizNext="goQuizNext"
                ></aw-multiple-quiz>
            </div>
        </div>
        <div v-if="resultFlag">
            <aw-quiz-result
                :result=result 
                v-on:goNext="goNext"
            ></aw-quiz-result>
        </div>
    </div>
</template>
<script>
import {pad} from '../../helpers'
export default {
    props : ['contents'],
    data(){
        return{
            currentQuiz : 0,
            result : _.map(new Array(this.contents.currentSlide.quiz.length),{
                result : false
            }),
            resultFlag : false
        }
    },
    methods:{
        answered(order,answer){
            console.log('order: ' + order + ' answer: ' + answer);
            this.result[order] = answer;
        },
        goQuizNext(order){
            if(order < this.contents.currentSlide.quiz.length){
                this.currentQuiz = order;
            }else{
                this.currentQuiz = order;
                this.resultFlag = true
            }
        },
        goNext(){
            location.href = "./" + pad(this.contents.slideNumber + 1) + ".html";
        },
    },
    mounted(){
    }
}
</script>